import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { AppContextService } from '../../../app-context/app-context.service';
import { OrganizationService } from '../../../organization/organization.service';
import { BaseOrganizationProfile } from '../../../organization/organization';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PageTitleComponent } from '../../../page-title/page-title.component';
import { LoadingDirective } from '@styleguide/loading/loading.directive';

import { ErrorsComponent } from '@styleguide/error/errors/errors.component';
import { PasswordRequestResetComponent } from '../password-request-reset/password-request-reset.component';
import { IfAppIdDirective } from '../../../app-context/if-app-id.directive';
import { ValidatePasswordResetTokenComponent } from '../validate-password-reset-token/validate-password-reset-token.component';
import { PasswordResetComponent } from '../password-reset/password-reset.component';
import { LoginFormComponent } from '../login-form/login-form.component';

enum ComponentStates {
  requestToken,
  validateResetToken,
  resetPassword,
  login,
  loading,
  missingRequiredOrganizationId,
}

@Component({
  selector: 'kgr-password-reset-flow',
  templateUrl: './password-reset-flow.component.html',
  styleUrls: ['./password-reset-flow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PageTitleComponent,
    LoadingDirective,
    ErrorsComponent,
    PasswordRequestResetComponent,
    IfAppIdDirective,
    ValidatePasswordResetTokenComponent,
    PasswordResetComponent,
    LoginFormComponent,
  ],
})
export class PasswordResetFlowComponent implements OnInit {
  readonly ComponentStates = ComponentStates;

  state = signal<ComponentStates>(ComponentStates.requestToken);
  organizationId = signal<number>(null);
  passwordResetToken = signal<string>(undefined);

  get redirectCommands(): string[] {
    if (this.appContextService.isAppId('club_offering')) {
      return ['/', this.organizationId() + ''];
    } else {
      return ['/'];
    }
  }

  constructor(
    private appContextService: AppContextService,
    private organizationService: OrganizationService<BaseOrganizationProfile>,
    private route: ActivatedRoute,
  ) {
    if (this.appContextService.isAppId('club_offering')) {
      this.organizationService.organization$.pipe(takeUntilDestroyed()).subscribe((organization: BaseOrganizationProfile | undefined) => {
        this.organizationId.set(organization?.id);
        if (organization === undefined) {
          this.state.set(ComponentStates.missingRequiredOrganizationId);
        }
      });
    }
  }

  ngOnInit() {
    if (this.route.snapshot.params.token) {
      this.onValidatedPasswordResetToken(this.route.snapshot.params.token);
    }
  }

  onRequestResetTokenDone() {
    this.state.set(ComponentStates.validateResetToken);
    this.scrollParentFrame();
  }

  onValidatedPasswordResetToken(token: string) {
    this.passwordResetToken.set(token);
    this.state.set(ComponentStates.resetPassword);
    this.scrollParentFrame();
  }

  private scrollParentFrame() {
    window['parentIFrame']?.scrollToOffset(0, 0);
  }

  onPasswordResetSuccessLoginToken($event: string) {
    this.state.set(ComponentStates.login);
  }
}
